var _style, _ellipse, _linearGradient, _radialGradient, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgV8Ignition(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4485 4485",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a,.b{opacity:.2}.c{fill:#424242}.d{fill:#9e9e9e}.e{stop-color:#fff}.f{stop-opacity:0}.j{stop-color:#231f20}.k{fill:#263238}.l{fill:#fff}")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2240,
    cy: 2306,
    fill: "#4285f4",
    rx: 1571,
    ry: 1549
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1707,
    x2: 3785,
    y1: 1734,
    y2: 3811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "j",
    offset: 0,
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    className: "j f",
    offset: 1
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 1000,
    cy: 384,
    r: 4480,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "e",
    offset: 0,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    className: "e f",
    offset: 1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2240 3830c-863 0-1564-687-1571-1537v12c0 855 703 1549 1571 1549s1571-694 1571-1549v-12c-7 850-708 1537-1571 1537z",
    className: "a k"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2240 782c863 0 1564 687 1571 1537v-12c0-855-703-1549-1571-1549S669 1451 669 2306v12c7-849 708-1536 1571-1536z",
    className: "b l k"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1867 1124v463l373 501 373-514v-450h441l431-746H996l430 746z",
    className: "c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1772 1124h-346l123 213h223zm936 213h223l123-213h-346z",
    className: "d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2613 3365v-305l-373-512-373 512v305h-440l-432 746h2490l-430-746z",
    className: "c"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2613 1536l-373 515-373-503v39l373 501 373-514z",
    className: "a k"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M996 378h2488l-15 26H1011z",
    className: "b l k"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1867 3098l374-513 372 513v-38l-372-512-374 511zm1617 1012H996l15-27h2458z",
    className: "a k"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M3484 4110l-15-27-303-526c321-231 549-579 621-980L2335 1106l-195 2295 689 709 656 1-1-1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8e8e8",
    d: "M2335 1106l-7e2 1401h508l-3 894 709-1409h-517z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2335 1106l-687 1376h495l-3 894 696-1384h-504z",
    className: "l"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1867 1124h-441l123 213h318zm746 213h318l123-213h-441z",
    className: "d"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2613 1312v25h318l15-26zm-746 0-333-1 15 26h318z",
    className: "k",
    opacity: 0.3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M3811 2318v-12c0-536-277-1009-697-1287l371-641H996l370 641c-420 278-697 751-697 1287v12c4 509 258 960 646 1240l-304 525-15 27-1 1h2489l-1-1-15-27-303-526c389-279 642-729 646-1239z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgV8Ignition);
export default __webpack_public_path__ + "static/media/v8-ignition.0025a0c854674f7e7d9b428f6e3c7d5f.svg";
export { ForwardRef as ReactComponent };